import { useState, Fragment } from "react";
import { Spinner } from "@chakra-ui/react";
import { useParams } from "react-router-dom";

import Quote from "./Quote";
import Error from "../Error";
import Confirmation from "./Confirmation";
import { useGetOrdersetTripInfoQuery, useGetTripInfoQuery } from "../../store/api.slice";

const Trips = () => {
  const { ref } = useParams();
  const [invalid, setInvalid] = useState(false);
  const [show, setShow] = useState(false);
  const { data: trips, isLoading } = useGetTripInfoQuery(ref);
  const { data: ordersetTrip, isLoading: isChecking } = useGetOrdersetTripInfoQuery(ref);

  if (!ref) setInvalid(true);


  if (ordersetTrip) {
    return (
      <Confirmation
        tripData={ordersetTrip.data}
        paid={true}
      />
    );
  }

  return (
    <Fragment>
      {invalid ? <Error /> : (isLoading || isChecking) ?
        <Spinner
          thickness="4px" speed="0.65s" color="red.500"
          className="h-[30px] w-[30px] absolute bottom-[50%] top-[50%] left-[50%] right-[50%]" />
        : ((trips && trips.data && trips.data.quote && (!trips.data.quote.charge || trips.data.quote.charge === undefined)) || show) ? <Quote tripData={trips.data} />
          : <Confirmation tripData={trips.data} paid={trips.data["is_paid"]} onchange={() => setShow(true)}/>
      }
    </Fragment>
  );
};

export default Trips;